<script>
	/**
	 * This top-level route allows a teacher to modify their account details.
	 */
	const accountService = require('services/accountService');
	const pubsub = require('events/pubsub');

	module.exports = {
		props: ['onReady'],
		modelData: ['userContext', 'myAccountTab'],
		components: {
			about: require('./my-account-tabs/account-about-me.vue').default,
			teaching: require('./my-account-tabs/account-teaching.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		data() {
			return {
				editAccount: null,
				originalAccount: null
			};
		},
		watch: {
			'userContext.email'(email) {
				if (email && this.originalAccount && this.editAccount) {
					this.originalAccount.email = email;
					this.editAccount = { ...this.editAccount, email };
				}
			}
		},
		computed: {
			isExternalLogin() {
				//is external
				const originalAccount = this.originalAccount;
				const isClever = originalAccount && originalAccount.type === 'clever' && originalAccount.clever;
				const isGoogle = originalAccount && originalAccount.type === 'google' && originalAccount.google;

				return isClever || isGoogle;
			}
		},
		mounted() {
			pubsub.subscribe('submit-succeeded', evData => {
				if (evData.formName === 'editAccount') {
					pubsub.publish('logged-in');
					pubsub.publish('message-success', 'Account modified');
				}
				return true;
			});

			accountService.teacherGetAccount().then(account => {
				account.allValid = false;

				this.editAccount = account;
				this.originalAccount = { ...account };
				this.$emit('data-ready');
			});

			// send ready notice to parent
			this.onReady?.();
		}
	};
</script>
<template>
	<main
		id="content"
		class="main my-account">
		<header class="main-header -has-nav">
			<div class="wrapper">
				<h1 class="main-header-title">My Account</h1>
				<tab-container
					class="print-hidden"
					model-key="myAccountTab">
					<button data-tab="about">Account</button>
					<button data-tab="teaching">Profile</button>
				</tab-container>
			</div>
		</header>
		<keep-alive>
			<component
				:edit-account="editAccount"
				:original-account="originalAccount"
				:is-external-login="isExternalLogin"
				:is="myAccountTab"
				ref="myAccountTabPanel"
				:data-panel="myAccountTab">
			</component>
		</keep-alive>
	</main>
</template>
